import React from "react";
import { Utensils } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const GastronomySection: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="section bg-white">
      <div className="container-custom">
        {/* Gusturi care spun povești */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/mancare.png"
                alt="Traditional food"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-romanian-yellow rounded-xl flex items-center justify-center shadow-lg">
              <Utensils className="w-12 h-12 text-romanian-blue" />
            </div>
          </div>
          <div>
            <span className="text-romanian-red font-semibold text-sm uppercase tracking-wider">
              {t.experience.traditionalGastronomy}
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-romanian-blue mt-2 mb-6">
              {t.experience.tastesTitle}
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-4">
              {t.experience.tastesDesc1}
            </p>
            <p className="text-gray-600 text-lg leading-relaxed">
              {t.experience.tastesDesc2}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GastronomySection;
